import { useSetRecoilState } from 'recoil'
import { Moment } from 'moment'
import { createQueryKeys } from '@lukemorales/query-key-factory'
import apiClient from '../service/api'
import { usersAtom } from '../atoms/users'
import { PaginationParams } from '../types/list'

export const useUserActions = () => {
  const setUserInfo = useSetRecoilState(usersAtom)

  async function getUserInfo() {
    const { data } = await apiClient.get('/v1/auth/me')
    setUserInfo(data)
    return data
  }

  return {
    getUserInfo,
  }
}

/**
 * GET Users
 */
export const getUsers = async (params: PaginationParams & { email?: string }) => {
  const { data } = await apiClient.get('/v1/users', { params })
  return data
}

export const getUserDetails = async (userId: number) => {
  const { data } = await apiClient.get(`/v1/users/${userId}`)
  return data
}

export const downloadCSV = async (startDate: Moment, endDate: Moment) => {
  try {
    const startDateStr = startDate.format('YYYYMMDD')
    const endDateStr = endDate.format('YYYYMMDD')

    const response = await apiClient.get('/v1/users/csv', {
      params: { startDate: startDateStr, endDate: endDateStr },
      responseType: 'blob',
    })

    const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = downloadUrl
    link.setAttribute('download', `users_${startDateStr}_to_${endDateStr}.csv`)
    document.body.appendChild(link)
    link.click()
    link.remove()
  } catch (e) {
    console.log(e)
  }
}

export const userQueries = createQueryKeys('user', {
  detail: (userId: number) => ({
    queryKey: [userId],
    queryFn: () => getUserDetails(userId),
  }),
})
